module.exports = __webpack_public_path__ + "static/img/resume_B.c46cf64.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/resume_B.jpeg
// module id = mBx/
// module chunks = 3